import PropTypes from 'prop-types';
import { cva } from 'class-variance-authority';
import { cn } from '@/shared/utils/cn.js';

const logoContainerVariants = cva(
  'flex items-center justify-center transition-colors duration-300',
  {
    variants: {
      interactive: {
        true: 'focus-visible:ring-primary-90/40 dark:focus-visible:ring-primary-80/45 cursor-pointer rounded-md focus:outline-none focus-visible:ring-2',
        false: '',
      },
    },
    defaultVariants: {
      interactive: false,
    },
  },
);

const imageVariants = cva('object-contain transition-all duration-300', {
  variants: {
    size: {
      sm: 'h-8 w-auto',
      md: 'h-10 w-auto',
      lg: 'h-12 w-auto',
      xl: 'h-14 w-auto',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

const Logo = ({
  src,
  darkSrc,
  alt = 'لوگو سیستم',
  size = 'md',
  onClick,
  className,
  imageClassName,
  ...props
}) => {
  const renderLogoImage = (source, modeClassName) => (
    <img
      src={source}
      alt={alt}
      className={cn(imageVariants({ size }), modeClassName, imageClassName)}
      draggable="false"
      loading="lazy"
    />
  );

  const logoContent = darkSrc ? (
    <>
      {renderLogoImage(src, 'dark:hidden')}
      {renderLogoImage(darkSrc, 'hidden dark:block')}
    </>
  ) : (
    renderLogoImage(src)
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cn(logoContainerVariants({ interactive: true }), className)}
        {...props}
      >
        {logoContent}
      </button>
    );
  }

  return (
    <div
      className={cn(logoContainerVariants({ interactive: false }), className)}
      {...props}
    >
      {logoContent}
    </div>
  );
};

Logo.propTypes = {
  src: PropTypes.string.isRequired,
  darkSrc: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  onClick: PropTypes.func,
  className: PropTypes.string,
  imageClassName: PropTypes.string,
};

export default Logo;
